import React, { Component } from "react";
import { Button, Icon, Pagination } from "semantic-ui-react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import "./styles.scss";
import OmProjectForm from "../../components/OmProjectForm";
import {
    getOmProjectList,
    addOmProject,
    updateOmProject,
    deleteOmProject
} from "../../core/actions/omProjectAction";
import { exportFileAction } from "../../core/actions/commonAction";
import ProjectTable from "../../components/ProjectTable";
import CONSTANT from "../../core/constant/constant";
import BackToTop from "../../components/BackToTop";

class OmProject extends Component {
    constructor() {
        super();
        this.state = {
            tableStructure: [
                {
                    label: "labels.id",
                    type: "id",
                    isClass: "om-project-small-col"
                    
                },
                {
                    label: "labels.projectCode",
                    type: "projectCode",
                    isClass: "om-project-medium-col",
                    sort: true
                },
                {
                    label: "labels.projectName",
                    type: "projectName",
                    isClass: "om-project-large-col",
                },
                {
                    label: "labels.employeeCode",
                    type: "employeeCode",
                    isClass: "om-project-medium-col",
                },
                {
                    label: "labels.employeeName",
                    type: "employeeName",
                    isClass: "om-project-large-col",
                }
            ],
            paramList: {
                isSearch: 0,
                projectId: "",
                employeeId: "",
                currentPage: "",
                pageRecord: CONSTANT.pageRecord,
                sortBy: "projectCode-ASC",
                employeeBy: "firstName-ASC",
                projectBy: "projectCode-ASC"
            },
            omProject: {
                projectId: "",
                employeeId: ""
            },
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
            data: "",
            projectData: "",
            employeeData: "",
            totalPage: 0,
            activePage: 1,
            disabled: true,
            errorCode: "",
            successCode: "",
            unSelectRow: false,
            isSearch: 0,
            btnDisable: false,
            exportDisabled: false,
            rowId: "",
            isAdded: false            
        };
    }

    componentWillMount() {
        // Call API omProject-list, show list omProject
        this.props.getOmProjectList(this.state.paramList);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.omProjectReducer.isLoading) {
            this.clearOmProject();
            if (this.state.isAdded === true) {
                this.getList();
            } else {
                this.props.getOmProjectList(this.state.paramList);
            }
        } else {
            let data = nextProps.omProjectReducer.dataOmProject.employeeProject;
            let projectData = nextProps.omProjectReducer.dataOmProject.omProject;
            let employeeData = nextProps.omProjectReducer.dataOmProject.employeeWorking;
            this.setState({
                data: data,
                projectData: projectData,
                employeeData: employeeData,
                totalPage: nextProps.omProjectReducer.dataOmProject.totalPage,
                activePage: nextProps.omProjectReducer.dataOmProject.currentPage || 1,
                btnDisable: false
            });

            // No data
            if (!data || (data && !data[0])) {
                this.setState({
                    errorCode: "018",
                    exportDisabled: true
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.omProjectReducer.errorCode = "";
                    }.bind(this),
                    2000
                );

            } else {
                this.setState({
                    exportDisabled: false
                });
            }

            // Data have success code
            if (nextProps.omProjectReducer.successCode) {
                this.setState({
                    successCode: nextProps.omProjectReducer.successCode,
                });
                if (this.state.isAdded === true) {
                    this.clearParamList(false);
                }
                setTimeout(
                    function () {
                        this.setState({ successCode: "" });
                        nextProps.omProjectReducer.successCode = ""
                    }.bind(this),
                    2000
                );
            }

            if (nextProps.omProjectReducer.errorCode) {
                this.setState({
                    errorCode: nextProps.omProjectReducer.errorCode,
                });
                setTimeout(
                    function () {
                        this.setState({ errorCode: "" });
                        nextProps.omProjectReducer.errorCode = "";
                    }.bind(this),
                    2000
                );
            }

        }
    }

    async getList() {
        let clrParam = await this.clearParamList(false);
        return this.props.getOmProjectList(this.state.paramList);       
    }

    // Event when click btn Search
    async searchOmProject() {
        this.clearError();
        this.setState({ btnDisable: true });
        const projectId = this.state.omProject.projectId;
        const employeeId = this.state.omProject.employeeId;

        await this.setState({
            paramList: {
                isSearch: 1,
                projectId: projectId,
                employeeId: employeeId,
                currentPage: 1,
                pageRecord: CONSTANT.pageRecord,
                sortBy: this.state.paramList.sortBy,
                employeeBy: "firstName-ASC",
                projectBy: "projectCode-ASC"
            },
            disabled: true,
            unSelectRow: false,
            isSearch: 1,
            activePage: 1
        });

        return this.props.getOmProjectList(this.state.paramList);
    }

    // Event when click btn Add
    addOmProject = () => {
        if (!this.checkValidate()) return;
        
        this.setState({ btnDisable: true });
        const projectId = this.state.omProject.projectId;
        const employeeId = this.state.omProject.employeeId;

        this.setState({isAdded: true});
        return this.props.addOmProject({
            projectId: projectId,
            employeeId: employeeId
        });
    }

    // Event when click btn Update 
    updateOmProject = () => {
        if (!this.checkValidate()) return;
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        const projectId = this.state.omProject.projectId;
        const employeeId = this.state.omProject.employeeId;
        this.setState({isAdded: false});
        return this.props.updateOmProject({
            id: id,
            projectId: projectId,
            employeeId: employeeId
        });
    }

    // Delete omProject
    deleteOmProject = async () => {
        this.setState({ btnDisable: true });
        const id = this.state.rowId;
        this.clearOmProject();
       
        if (this.state.data.length === 1) {
            this.setState(prevState => ({
                paramList: {
                    ...prevState.paramList,
                    currentPage: 1
                }
            }));
        }
        this.setState({isAdded: false});
        return this.props.deleteOmProject({ id: id });
    }

    // Event when click btn Export
    omProjectExportAction = () => {
        this.clearError();
        const exportParam = {
            projectId: this.state.paramList.projectId,
            employeeId: this.state.paramList.employeeId,
            sortBy: this.state.paramList.sortBy
        };
        this.props.exportFileAction({
            'urlGetkey': 'OMProject/requestSecretKey',
            'urlDownfile':  'OMProject/omProjectExport'
        }, exportParam)
    }
    

    // Event when click clear omProject
    clearOmProject = () => {
        this.setState({
            omProject: {
                projectId: "",
                employeeId: ""
            },
            disabled: true,
            unSelectRow: false,
            rowId: "",
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }

    // Clear input error text
    clearError = () => {
        this.setState({
            inputSubmit: {
                isSubmit: false,
                formError: {}
            },
        });
    }

    // Clear param list call API
    clearParamList = (isSort) => {
        this.setState({
            paramList: {
                isSearch: 0,
                projectId: "",
                employeeId: "",
                currentPage: "",
                pageRecord: CONSTANT.pageRecord,
                employeeBy: "firstName-ASC",
                projectBy: "projectCode-ASC",
                sortBy: (isSort !== true) ? "projectCode-ASC" : this.state.paramList.sortBy
            },
        });
    }

    // Handle on change input
    changeOmProject = evt => {
        const name = evt._name;
        const value = evt._value;
        this.setState(prevState => ({
            omProject: {
                ...prevState.omProject,
                [name]: value
            }
        }));
        this.setState(prevState => ({
            inputSubmit: {
                ...prevState.inputSubmit,
                formError: {
                    ...prevState.inputSubmit.formError,
                    [name]: ""
                }
            }
        }));
        
    }

    // Event when click table row
    onRowClick = val => {
        this.clearError();
        let _omProject = {
            projectId: val.projectId !== null ? val.projectId : "",
            employeeId: val.employeeId !== null ? val.employeeId : ""
        };
        this.setState({
            disabled: false,
            omProject: _omProject,
            unSelectRow: true,
            rowId: val.id
        });
    }

    // Event when click sort table
    sortBy = async val => {
        await this.setState(prevState => ({
            paramList: {
                ...prevState.paramList,
                sortBy: val,
                rowId: val.id
            }
        }));
        this.props.getOmProjectList(this.state.paramList);
    }

    // Event when click btn pagination
    async handlePaginationChange(val) {
        await this.setState({
            activePage: val,
            paramList: {
                isSearch: this.state.isSearch,
                projectId: this.state.paramList.projectId,
                employeeId: this.state.paramList.employeeId,
                currentPage: val,
                pageRecord: CONSTANT.pageRecord,
                employeeBy: "firstName-ASC",
                projectBy: "projectCode-ASC",
                sortBy: this.state.paramList.sortBy
            }
        });

        return this.props.getOmProjectList(this.state.paramList);
    }

    // Check validate form
    checkValidate = () => {
        let isValidate = false;
        let _formError = {};
        (this.state.omProject.projectId === "") ? _formError["projectId"] = "message.300" : _formError["projectId"] = "";
        (this.state.omProject.employeeId === "") ? _formError["employeeId"] = "message.301" : _formError["employeeId"] = "";

        if (this.state.omProject.projectId !== "" 
            && this.state.omProject.employeeId !== "") {
            isValidate = true;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: {}
                }
            }));
        } else {
            isValidate = false;
            this.setState(prevState => ({
                inputSubmit: {
                    ...prevState.inputSubmit,
                    formError: _formError
                }
            }));
        }
        return isValidate;
    }
    
    render() {
        const { t } = this.props;
        const { activePage, errorCode, successCode, btnDisable} = this.state;
        return (
            <div>
                <h2 className="page-heading">
                    <span onClick={() => setTimeout(function() { window.location = "/employee" }, 500)}>
                        {t("navigation.master")}
                    </span>
                    /{" "}
                    <span onClick={() => setTimeout(function() { window.location = "/om-project-management" }, 500)}>
                        {t("navigation.omProjectManagement")}
                    </span>
                </h2>
                <div className="list-actions">
                    <Button
                        primary
                        disabled={btnDisable}
                        onClick={() => this.searchOmProject()}
                    >
                        <Icon name="search" />
                        {t("button.search")}
                    </Button>
                    <Button
                        primary
                        disabled={btnDisable}
                        onClick={() => this.addOmProject()}
                    >
                        <Icon name="add circle" />
                        {t("button.add")}
                    </Button>
                    <Button 
                    primary 
                    disabled={this.state.disabled} 
                    className="update-btn"
                    onClick={() => this.updateOmProject()}
                    >
                        <Icon name="edit" />
                        {t("button.update")}
                    </Button>
                    <Button
                        primary
                        disabled={this.state.disabled}
                        onClick={() => this.deleteOmProject()}
                        className="delete-btn"
                    >
                        <Icon name="trash alternate outline" />
                        {t("button.delete")}
                    </Button>
                    <Button
                        disabled={this.state.exportDisabled}
                        onClick={e => this.omProjectExportAction()}
                    >
                        <Icon name="file excel outline" />
                        {t("button.export")}
                    </Button>
                    <Button onClick={() => this.clearOmProject()}>
                        <Icon name="refresh" />
                        {t("button.clearAll")}
                    </Button>
                </div>
                <OmProjectForm
                    omProjectData={this.state.omProject}
                    projectData={this.state.projectData}
                    employeeData={this.state.employeeData}
                    isError={this.state.inputSubmit.formError}
                    changeOmProject={input => this.changeOmProject(input)}
                />
                {successCode ? (
                    <div className="success-message list-error-message">
                        {t("message." + successCode)}
                    </div>
                ) : (
                        ""
                    )}    
                {errorCode ? (
                    <div className="error-message list-error-message">
                        {t("message." + errorCode)}
                    </div>
                ) : (
                        ""
                    )}
                <ProjectTable
                    tableStructure={this.state.tableStructure}
                    dataList={this.state.data}
                    onRowClick={val => this.onRowClick(val)}
                    unSelectRow={this.state.unSelectRow}
                    defaultSort={this.state.paramList.sortBy}
                    sortBy={val => this.sortBy(val)}
                />
                <div className="table-paging">
                    {this.state.data && this.state.data[0] ? (
                        <Pagination
                            size="tiny"
                            activePage={activePage}
                            firstItem={null}
                            lastItem={null}
                            totalPages={this.state.totalPage}
                            prevItem={{
                                disabled: this.state.activePage == 1,
                                content: <Icon name="chevron left" />,
                                icon: true
                            }}
                            nextItem={{
                                disabled: this.state.activePage == this.state.totalPage,
                                content: <Icon name="chevron right" />,
                                icon: true
                            }}
                            onPageChange={(e, { activePage }) =>
                                this.handlePaginationChange(activePage)
                            }
                        />
                    ) : (
                            ""
                        )}
                </div>
                <BackToTop />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ...state
});

const mapDispatchToProps = dispatch => ({
    getOmProjectList: opt => dispatch(getOmProjectList(opt)),
    addOmProject: opt => dispatch(addOmProject(opt)),
    updateOmProject: opt => dispatch(updateOmProject(opt)),
    exportFileAction: (url, param) => dispatch(exportFileAction(url, param)),
    deleteOmProject: opt => dispatch(deleteOmProject(opt))
});

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(OmProject);
